
import React from 'react';
import mission from '../assets/mission.jpg';
import missionhair from '../assets/mission hair.jpg';


const OurMission = () => {
  return (
    <>
        <div className="container pt-5">
        <div className="row align-items-center animate-form">
            <div className="col-sm-6 d-flex">
                {/* <!-- <img src="images/mision.jpg" alt="Nail Services" style="width: 50%; height: 500px; border-radius: 0px;"> --> */}

                <img src={mission} className=" pb-4 ps-4" alt="" style={{width: "50%", height: "500px", borderradius: "0px"}}/>
                <img src={missionhair} className=" pb-4 ps-4 mt-4"  alt="" style={{width: "50%", height: "500px", borderradius: "0px"}}/>

            </div>
            <div className="col-sm-6">
                <h1 className="service-header text-center"  style={{color: "#b37777", fontstyle: "italic", fontfamily:'"TAN TWINKLE", cursive'}}>Our Mission</h1>
                <p>
                    “At MSilk Spa, our goal is to help you feel confident, beautiful, and relaxed. Self-care isn’t a luxury—it’s essential.”
                </p>
            </div>
        </div>
    </div>
    </>
  )
}

export default OurMission;